import {DetailsChartGaugeColor} from "../custom";

export const APPLICATION_GAUGE_PALETTE_MAX_5: DetailsChartGaugeColor[] = [
  {
    maxValue: 0,
    color: '#333333'
  },
  {
    maxValue: 1,
    color: '#00aa00'
  },
  {
    maxValue: 2,
    color: '#bfd100'
  }, {
    maxValue: 3,
    color: '#ffc107'
  },
  {
    maxValue: 4,
    color: '#f87001'
  },
  {
    maxValue: 5,
    color: '#aa0000'
  }
];

export const TREATMENT_GAUGE_PALETTE_MAX_9: DetailsChartGaugeColor[] = [
  {
    maxValue: 1,
    color: '#00aa00'
  }, {
    maxValue: 9,
    color: '#aa0000'
  }
];

export const TREATMENT_GAUGE_PALETTE_MAX_5: DetailsChartGaugeColor[] = [
  {
    maxValue: 0,
    color: '#333333'
  },
  {
    maxValue: 1,
    color: '#00aa00'
  },
  {
    maxValue: 2,
    color: '#bfd100'
  }, {
    maxValue: 3,
    color: '#ffc107'
  },
  {
    maxValue: 4,
    color: '#f87001'
  },
  {
    maxValue: 5,
    color: '#aa0000'
  }
];


export const RISK_ASSESSMENT_GAUGE_PALETTE_MAX_5: DetailsChartGaugeColor[] = [
  {
    maxValue: 0,
    color: '#333333'
  },
  {
    maxValue: 1,
    color: '#00aa00'
  },
  {
    maxValue: 2,
    color: '#bfd100'
  }, {
    maxValue: 3,
    color: '#ffc107'
  },
  {
    maxValue: 4,
    color: '#f87001'
  },
  {
    maxValue: 5,
    color: '#aa0000'
  }
];

export const AI_ASSESSMENT_GAUGE_PALETTE_MAX_5: DetailsChartGaugeColor[] = [
  {
    maxValue: 0,
    color: '#333333'
  },
  {
    maxValue: 1,
    color: '#00aa00'
  },
  {
    maxValue: 2,
    color: '#bfd100'
  }, {
    maxValue: 3,
    color: '#ffc107'
  },
  {
    maxValue: 4,
    color: '#f87001'
  },
  {
    maxValue: 5,
    color: '#aa0000'
  }
];

export const COVID_ASSESSMENT_GAUGE_PALETTE_MAX_5: DetailsChartGaugeColor[] = [
  {
    maxValue: 0,
    color: '#333333'
  },
  {
    maxValue: 1,
    color: '#00aa00'
  },
  {
    maxValue: 2,
    color: '#bfd100'
  }, {
    maxValue: 3,
    color: '#ffc107'
  },
  {
    maxValue: 4,
    color: '#f87001'
  },
  {
    maxValue: 5,
    color: '#aa0000'
  }
];

export const APP_ASSESSMENT_GAUGE_PALETTE_MAX_5: DetailsChartGaugeColor[] = [
  {
    maxValue: 0,
    color: '#333333'
  },
  {
    maxValue: 1,
    color: '#00aa00'
  },
  {
    maxValue: 2,
    color: '#bfd100'
  }, {
    maxValue: 3,
    color: '#ffc107'
  },
  {
    maxValue: 4,
    color: '#f87001'
  },
  {
    maxValue: 5,
    color: '#aa0000'
  }
];

export const RID_GAUGE_PALETTE_MAX_3: DetailsChartGaugeColor[] = [
  {
    maxValue: 0,
    color: '#333333'
  },
  {
    maxValue: 1,
    color: '#00aa00'
  },
  {
    maxValue: 2,
    color: '#ffc107'
  },
  {
    maxValue: 3,
    color: '#aa0000'
  }
];

export const DEFAULT_GAUGE_PALETTE = RISK_ASSESSMENT_GAUGE_PALETTE_MAX_5;
